import { apiGet } from "../client";
import type { CurrencyListResponseApi } from "../models/currency";

export async function getAllCurrencies(): Promise<CurrencyListResponseApi> {
	return apiGet<CurrencyListResponseApi>("global/currencies");
}
